import { GovIcon } from '@gov-design-system-ce/react/gov-icon';
import { GovTooltip } from '@gov-design-system-ce/react/gov-tooltip';
import type { DocumentDownloadItemCoreProps } from '@gov-nx/ui/types/DocumentDownload';
import { formatBytes } from '@gov-nx/utils/common/File/file-size';

export const DocumentDownloadItem = ({
	name,
	size,
	loading,
	children,
}: DocumentDownloadItemCoreProps) => {
	const suffix =
		name && name.indexOf('.') !== -1 ? name.split('.').pop() : undefined;
	return (
		<>
			{loading ? (
				<GovIcon
					slot="icon-start"
					name="loader"
					type="components"
					size="2xl"
					color="neutral"
					className="gov-spin-animation"
				/>
			) : (
				<GovIcon
					slot="icon-start"
					name="file-earmark-text"
					type="templates"
					size="2xl"
					color="neutral"
				/>
			)}
			<div className="flex flex-col text-left">
				<GovTooltip placement="top">
					<GovTooltip.Trigger
						asChild
						className="inline-block overflow-hidden w-[184px] whitespace-nowrap text-ellipsis text-(--text-secondary)! font-normal! text-left cursor-help!">
						<span>{name}</span>
					</GovTooltip.Trigger>
					<GovTooltip.Content
						color="primary"
						size="s">
						{name}
					</GovTooltip.Content>
				</GovTooltip>
				<span className="text-body-s text-(--text-tertiary)!">
					{size && formatBytes(size, 2)}
					{suffix && <span className="uppercase">, {suffix}</span>}
				</span>
			</div>
			{children ? (
				children
			) : (
				<GovIcon
					slot="icon-end"
					name="chevron-down"
					type="components"
				/>
			)}
		</>
	);
};
